import { FC } from "react";

import LogoMBA from "../../../assets/auth-logo-mba.svg";
import { ReactComponent as MBAAssistantIcon } from "../../../assets/logo-mba.icon.svg";
import { Logo } from "../../enums/logo.enum";

export const getLogoImg = (logo: Logo, _onlyFullImg = false, _smallTivaLogo = false): string => {
    switch (logo) {
        case Logo.mba:
        default:
            return LogoMBA;
    }
};

export const getHederLogoImg = (logo: Logo, _darkTheme = false): string => {
    switch (logo) {
        case Logo.mba:
        default:
            return LogoMBA;
    }
};

export const getAssistantIcon = (logo: Logo): FC<React.SVGProps<SVGSVGElement>> => {
    switch (logo) {
        case Logo.mba:
        default:
            return MBAAssistantIcon;
    }
};
